import { Component, Input } from '@angular/core'
import { QRCodeComponent } from 'angularx-qrcode'

@Component({
  selector: 'ngx-qrcode',
  template: `
    <qrcode
      [qrdata]="qrData"
      [width]="width"
      [errorCorrectionLevel]="'M'"
      [elementType]="format"
      [cssClass]="'qr-code'"
      [colorDark]="qrCodeColor"
      [colorLight]="backgroundColor"
      [id]="id"
    ></qrcode>
  `,
  imports: [QRCodeComponent]
})
export class QrcodeComponent {
  @Input() qrData = ''
  @Input() width = '100%'
  @Input() format = 'svg'
  @Input() qrCodeColor = '#000000ff'
  @Input() backgroundColor = '#ffffffff'
  @Input() id: string
}
